import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { WidgetController } from "..//WidgetController";

export type BackgroundGridItemProps = {
    column: number;
    row: number;
    controller: WidgetController;
}

export class BackgroundGridItem extends JSXComponent {
    props: BackgroundGridItemProps;

    constructor(props: BackgroundGridItemProps)
    {
        super(props);
    }

    element: HTMLElement =
        <div className="widget-bg" style={{ "grid-column": `${this.props.column} / ${this.props.column + 1}`, "grid-row": `${this.props.row} / ${this.props.row + 1}` }}></div>

    render(): HTMLElement {
        this.element.addEventListener("dragenter", (ev: DragEvent) => {
            this.props.controller.dragdrop.onDragEnterCell(this, ev);
        });

        this.element.addEventListener("dragleave", (ev: DragEvent) => {
            this.props.controller.dragdrop.onDragLeaveCell(this, ev);
        });

       this.element.addEventListener("dragover", (ev: DragEvent) => {
           if (ev.dataTransfer.types.indexOf("mso/widget") >= 0) {
               if (this.props.controller.dragdrop.canDrop(this.props.column, this.props.row)) {
                   ev.preventDefault();
               }
            }
        });

        this.element.addEventListener("drop", (ev: DragEvent) => {
            if (ev.dataTransfer.types.indexOf("mso/widget") >= 0) {
                this.props.controller.hightlightDropItems(this.props.column, this.props.row, 1, 1, false);
                if (this.props.controller.dragdrop.canDrop(this.props.column, this.props.row)) {
                    this.element.classList.remove("drop-highlight");
                    this.props.controller.dragdrop.drop(ev.dataTransfer.getData("mso/widget"), this.props.column, this.props.row);
                    ev.preventDefault();
                }
            }
        });

        return this.element;
    }

    public isInside(column: number, row: number, colSpan: number, rowSpan: number): boolean {
        return (column + colSpan) > this.props.column && column <= this.props.column &&
            (row + rowSpan) > this.props.row && row <= this.props.row;
    }
}